// SCSS
import './scss/style.scss';

// Polyfill
import 'babel-polyfill';
import 'promise-polyfill/src/polyfill';

// REACT COMPONENTS

// ES6 COMPONENTS

import './js/main';
